(ns dre.widgets.db
  (:require
   [dre.config :as config]
   [dre.i18n.utils :refer [tr-later]] 
   [dre.widgets.authors.views :as authors]
   [dre.widgets.authors.events :as e-authors]
   [dre.widgets.clinical-studies.views :as clinical-studies]
   [dre.widgets.clinical-studies.events :as e-clinical-studies]
   [dre.widgets.data-sources.views :as data-sources]
   [dre.widgets.data-sources.events :as e-data-sources]
   [dre.widgets.dates.views :as dates]
   [dre.widgets.dates.events :as e-dates]
   [dre.widgets.demographics.views :as demographics]
   [dre.widgets.demographics.events :as e-demographics]
   [dre.widgets.geography.views :as geography]
   [dre.widgets.geography.events :as e-geography]
   [dre.widgets.publication-type.views :as publication-type]
   [dre.widgets.publication-type.events :as e-publication-type]
   [dre.widgets.related-concepts.views :as related-concepts]
   [dre.widgets.related-concepts.events :as e-related-concepts]
   [dre.widgets.top-terms.views :as top-terms]
   [dre.widgets.top-terms.events :as e-top-terms]
   [dre.widgets.cooccurrence-matrix.views :as matrix]
   [dre.widgets.cooccurrence-matrix.events :as e-matrix]
   [dre.widgets.question-answering.views :as qa]
   [dre.widgets.question-answering.events :as e-qa]))

;; TODO implement used-in-search-sub for all widgets (missing Related Concepts, Ihme)
(defn registry
  []
  (remove nil? [(when (config/feature-enabled? e-qa/id)
                  {:id e-qa/id
                   :title (tr-later "AI Summarization")
                   :view qa/view
                   :set-loading-fx :dre.widgets.question-answering.events/set-loading
                   :init-fx :dre.widgets.question-answering.events/init
                   :priority 1})
                {:id e-related-concepts/id
                 :title (tr-later "Related Concepts")
                 :tooltip "View synonyms and child terms included in your search."
                 :view related-concepts/view
                 :init-fx :dre.widgets.related-concepts.events/init
                 :set-loading-fx :dre.widgets.related-concepts.events/set-loading
                 :priority 1}
                {:id e-data-sources/id
                 :title (tr-later "Data Sources")
                 :view data-sources/view
                 :init-fx :dre.widgets.data-sources.events/init
                 :set-loading-fx :dre.widgets.data-sources.events/set-loading
                 :used-in-search-sub :dre.widgets.data-sources.events/used-in-search?
                 :priority 1}
                {:id e-geography/id
                 :title (tr-later "Geography")
                 :view geography/view
                 :init-fx :dre.widgets.analysis.tag-distribution/init
                 :set-loading-fx :dre.widgets.analysis.tag-distribution/set-loading
                 :used-in-search-sub :dre.widgets.geography.events/used-in-search?
                 :priority 1}
                {:id e-demographics/id
                 :title (tr-later "Demographics")
                 :view demographics/view
                 :init-fx :dre.widgets.analysis.tag-distribution/init
                 :set-loading-fx :dre.widgets.analysis.tag-distribution/set-loading
                 :used-in-search-sub :dre.widgets.demographics.events/used-in-search?
                 :priority 1}
                {:id e-dates/id
                 :title (tr-later "Dates")
                 :view dates/view
                 :init-fx :dre.widgets.dates.events/init
                 :set-loading-fx :dre.widgets.dates.events/set-loading
                 :used-in-search-sub :dre.widgets.dates.events/used-in-search?
                 :priority 1}
                {:id e-clinical-studies/id
                 :title (tr-later "Clinical Trials")
                 :tooltip "Filter by clinical trial information: phase, status, or data availability. Additionally, filter by clinical study population size (all articles)."
                 :view clinical-studies/view
                 :init-fx :dre.widgets.clinical-studies.events/init
                 :set-loading-fx :dre.widgets.clinical-studies.events/set-loading
                 :used-in-search-sub :dre.widgets.clinical-studies.events/used-in-search?
                 :priority 2}
                {:id e-top-terms/id
                 :title (tr-later "Top Terms")
                 :tooltip "Filter on commonly mentioned terms."
                 :view top-terms/view
                 :init-fx :dre.widgets.top-terms.events/init
                 :set-loading-fx :dre.widgets.top-terms.events/set-loading
                 :used-in-search-sub :dre.widgets.top-terms.events/used-in-search?
                 :priority 2
                 :children [{:id "ALL" :title (tr-later "All")}
                            {:id "I" :title (tr-later "Interventions")}
                            {:id "O" :title (tr-later "Outcomes")}
                            {:id "C" :title (tr-later "Characteristics")}
                            {:id "THE" :title (tr-later "Therapeutic Procedure")}
                            {:id "GEN" :title (tr-later "Gene or Genome")}
                            {:id "DIS" :title (tr-later "Disease & Disorders")}
                            {:id "INJ" :title (tr-later "Injury")}
                            {:id "SYM" :title (tr-later "Symptom")}
                            {:id "CHE" :title (tr-later "Chemical")}
                            {:id "DRU" :title (tr-later "Drug")}
                            {:id "VIT" :title (tr-later "Vitamin")}
                            {:id "ANT" :title (tr-later "Antibiotic")}
                            {:id "VIR" :title (tr-later "Virus")}
                            {:id "CEL" :title (tr-later "Cell")}
                            {:id "ANA" :title (tr-later "Anatomy")}
                            {:id "MED" :title (tr-later "Medical Devices")}
                            {:id "BAC" :title (tr-later "Bacteria")}
                            {:id "SPE" :title (tr-later "Species")}
                            {:id "DIA" :title (tr-later "Diagnostic Procedure")}
                            {:id "LAB" :title (tr-later "Lab Procedure")}
                            {:id "MOL" :title (tr-later "Biomolecular research")}
                            {:id "PRO" :title (tr-later "Procedure")}
                            {:id "PHY" :title (tr-later "Physiology")}
                            {:id "BIO" :title (tr-later "Biologic Function")}
                            {:id "PHE" :title (tr-later "Phenomena")}
                            {:id "TST" :title (tr-later "Lab test result")}
                            {:id "ORG" :title (tr-later "Medical Organization")}
                            {:id "OCC" :title (tr-later "Medical Occupation")}
                            {:id "FOD" :title (tr-later "Food")}
                            {:id "DEM" :title (tr-later "Demographics")}]}
                {:id e-publication-type/id
                 :title (tr-later "Publication Type")
                 :view publication-type/view
                 :init-fx :dre.widgets.analysis.tag-distribution/init
                 :set-loading-fx :dre.widgets.analysis.tag-distribution/set-loading
                 :used-in-search-sub :dre.widgets.publication-type.events/used-in-search?
                 :priority 2}
                {:id e-authors/id
                 :title (tr-later "Authors")
                 :view authors/view
                 :init-fx :dre.widgets.authors.events/init
                 :set-loading-fx :dre.widgets.authors.events/set-loading
                 :used-in-search-sub :dre.widgets.authors.events/used-in-search?
                 :priority 3}
                {:id e-matrix/id
                 :title (tr-later "Co-occurrence Matrix")
                 :tooltip "Create a matrix of terms to see how often they appear together in your results."
                 :view matrix/view
                 :init-fx :dre.widgets.cooccurrence-matrix.events/init
                 :set-loading-fx :dre.widgets.cooccurrence-matrix.events/set-loading
                 :used-in-search-sub :dre.widgets.cooccurrence-matrix.events/used-in-search?
                 :priority 3}
                #_{:id e-burden-of-disease/id
                   :title (tr-later "Burden of Disease")
                   :view burden-of-disease/view
                   :init-fx :dre.widgets.burden-of-disease.events/init
                   :set-loading-fx :dre.widgets.burden-of-disease.events/set-loading
                   :priority 3}]))


(defn index
  []
  (into {} (map (juxt :id identity)) (registry)))
